import { Flex } from "@mantine/core";
import { HashLoader } from "react-spinners";
export const LimeLoader = () => {
  return (
    <Flex justify={"center"} align={"center"} h="80%">
      <HashLoader color="#74B587" size={100}></HashLoader>
    </Flex>
  );
};
